import Vue from "vue";
import { mapGetters } from "vuex";
import { CurrencyText, LoadingSpinner, PartDetailsLink } from "@/components";
import { stringHelper, formatDateTime } from "@/components/mixins";
import { BackorderService, ErrorLogService } from "@/services/";

export default Vue.extend({
    name: "BackorderRowDetails",

    components: { CurrencyText, LoadingSpinner, PartDetailsLink },
    mixins: [formatDateTime, stringHelper],

    props: {
        backorder: {
            type: Object,
            required: true,
        }
    },

    computed: {
        ...mapGetters([
            "user",
            "activeAccountId",
            "getContentItem",
            "tenantDetails",
            "hasPermission"
        ]),
        mostRecentFollowup(){
            if(this.backorder.BackorderRequestFollowupDtos  && 
                this.backorder.BackorderRequestFollowupDtos.length > 0)
            {
                return this.backorder.BackorderRequestFollowupDtos[0];
            }
            return false;
        }
    },


    mounted() {
        this.newCrmTicketNumber = this.backorder.CrmTicketNumber; 
        this.newDealerSupportNotes = this.backorder.DealerSupportNote; 
    },

    data: () => ({
        submittingBackorderAdditionalDetails: false,
        newCrmTicketNumber: "",
        newDealerSupportNotes: ""
    }),

    methods: {
        async SubmitBackorderAdditionalDetails(){
            try {

                this.submittingBackorderAdditionalDetails = true;
                var backorderCopy = this.backorder;
                backorderCopy.CrmTicketNumber = this.newCrmTicketNumber;
                backorderCopy.DealerSupportNote = this.newDealerSupportNotes;

                const result = await BackorderService.SubmitBackorderAdditionalDetails(backorderCopy);
               
                this.$store.commit("pushTimedMessage", {
                    header: "Success: CRM ticket number for backorder saved successfully.",
                    IsError: false,
                    seconds: 5,
                    sticky: true
                });
                var returnedBackorder = result.data;
                if(returnedBackorder){
                    this.backorder.CrmTicketNumber = returnedBackorder.CrmTicketNumber;
                    this.backorder.DealerSupportNote = returnedBackorder.DealerSupportNote;
                    this.backorder.CrmIncidentId = returnedBackorder.CrmIncidentId;
                }
                
            
            } catch (err) {
                ErrorLogService.LogException(err);
                this.$store.commit("pushTimedMessage", {
                    header: "Error: CRM ticket number for backorder failed to save.",
                    IsError: true,
                    seconds: 5,
                    sticky: true
                });
            } finally {
                this.submittingBackorderAdditionalDetails = false;
            }
        }        
    },
});
